/** Termine eines Bereichs in den naechsten 7 Tagen (F-01). Klick oeffnet den Kalender. */
import { useLiveQuery } from 'dexie-react-hooks';
import { useNavigate } from 'react-router-dom';
import { CalendarDays } from 'lucide-react';

import { getOccurrences } from '@/db/repositories/events';
import { useCalendarStore } from '@/store/calendar';
import { useUiStore } from '@/store/ui';
import { addDays, datePart, formatDe, today } from '@/lib/datetime';
import type { CalendarOccurrence, ID, LocalDateTime } from '@/domain/types';

const TAGE = 7;

export function BereichTermine({ areaId }: { areaId: ID }) {
  const navigate = useNavigate();
  const setView = useUiStore((s) => s.setCalendarView);
  const setAnchor = useCalendarStore((s) => s.setAnchor);
  const select = useCalendarStore((s) => s.select);
  const heute = today();
  const liste = useLiveQuery(async () => (await getOccurrences({
    from: `${heute}T00:00` as LocalDateTime,
    to: `${addDays(heute, TAGE)}T00:00` as LocalDateTime,
  })).filter((o) => o.areaId === areaId).sort((a, b) => String(a.start).localeCompare(String(b.start))),
  [heute, areaId], [] as CalendarOccurrence[]);

  function oeffnen(o: CalendarOccurrence) {
    setView('tag');
    setAnchor(datePart(String(o.start)));
    select(o);
    navigate('/kalender');
  }

  return (
    <section aria-label="Termine" className="flex flex-col gap-2 rounded-lg border border-line bg-surface px-4 py-3.5">
      <h2 className="flex items-center gap-1.5 text-sm font-semibold"><CalendarDays className="size-4 text-ink-faint" />Termine (7 Tage)</h2>
      {liste.length === 0 && <p className="text-sm text-ink-faint">Keine Termine in den nächsten {TAGE} Tagen.</p>}
      <ul className="flex flex-col">
        {liste.slice(0, 12).map((o) => (
          <li key={o.occurrenceId}>
            <button type="button" onClick={() => oeffnen(o)} className="flex w-full items-center gap-2 rounded px-1 py-0.5 text-left text-sm hover:bg-surface-raised">
              <span className="w-[7.5rem] shrink-0 tabular-nums text-ink-faint">{formatDe(String(o.start), o.allDay ? 'EEEEEE dd.MM.' : 'EEEEEE dd.MM. HH:mm')}</span>
              <span className="min-w-0 flex-1 truncate">{o.title || 'Ohne Titel'}</span>
            </button>
          </li>
        ))}
      </ul>
      {liste.length > 12 && <p className="text-[11px] text-ink-faint">+{liste.length - 12} weitere</p>}
    </section>
  );
}
